import { NgModule }       from '@angular/core';
import { BrowserModule  } from '@angular/platform-browser';
// import { FormsModule, ReactiveFormsModule }    from '@angular/forms';
import { HttpModule }     from '@angular/http';
// import { JsonpModule, JSONP_PROVIDERS }     from '@angular/http';
import { JsonpModule }     from '@angular/http';

// i18n module
import {TranslateModule} from 'ng2-translate/ng2-translate';

import { AppComponent }   from './app.component';


/* Main Feature Modules */
import { SharedModule }   from './shared/shared.module';
import { VoterInformationModule }  from './information/voterinformation.module';

/**This portion below only works when working with Webpack. For SystemJS, comment the following lines**/
import 'material-design-lite/dist/material.min.css';
import 'mdl-selectfield/dist/mdl-selectfield.min.css';
import '../css/styles.css';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports:      [
        BrowserModule,
        HttpModule,
        JsonpModule,
        TranslateModule.forRoot(),
        VoterInformationModule,
        SharedModule.forRoot()
    ],
      providers: [
        //   JSONP_PROVIDERS
  ],
    bootstrap:   [AppComponent]
})
export class AppModule {}


// WEBPACK FOOTER //
// ./app/app.module.ts